import { Info } from "@mui/icons-material";
import { Alert, Backdrop, Box, Button, Card, CircularProgress, Container, Link, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { ValidationCode } from "../enums/enums";
import { Validation } from "../models/Validation";
import { Helper } from "../services/Helper";
import { PartnerService } from "../services/PartnerService";

export default function ForgotPassword() {
    const [isValidating, setIsValidating] = useState(false);
    const [validation, setValidation] = useState(new Validation());
    const [phoneNumber, setPhoneNumber] = useState("");
    const partnerService = new PartnerService();

    function onSendTemporaryPassword() {
        setIsValidating(true);
        if (!Helper.HasValue(phoneNumber)) {
            setValidation({ Code: ValidationCode.ERROR, Message: "Enter your phone number." });
            setIsValidating(false);
        } else if (!Helper.IsValidPhoneNumber(phoneNumber)) {
            setValidation({ Code: ValidationCode.ERROR, Message: "Phone number should be 11 digits and start with 09." });
            setIsValidating(false);
        } else {
            partnerService.RequestNewPassword({ Username: phoneNumber }).then(response => {
                setValidation({ Code: response.IsSuccessful ? ValidationCode.VALID : ValidationCode.ERROR, Message: response.Message });
            }).catch(error => {
                setValidation({ Code: ValidationCode.ERROR, Message: error });
            }).finally(() => {
                setIsValidating(false);
            });
        }
    }

    return (
        <Container>
            <Backdrop open={isValidating} sx={{ zIndex: 100000 }}>
                <CircularProgress color="error"></CircularProgress>
            </Backdrop>
            <Card sx={{ marginTop: 15, padding: 2, marginX: "auto", maxWidth:400, boxShadow: { xs: 'none', md: 'var(--Paper-shadow)' } }}>
                <Typography variant="h4" sx={{ marginBottom: 4 }}>
                    Forgot password
                </Typography>
                <Typography variant="subtitle2" sx={{ marginBottom: 4 }}>
                    Enter your registered phone number to generate a temporary password.
                </Typography>
                <Box sx={{ marginBottom: 4, marginTop: 2 }}>
                    <TextField label="Registered Phone Number" variant="outlined" fullWidth={true} value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)}></TextField>
                </Box>
                {
                    validation.Code == ValidationCode.ERROR &&
                    <Alert icon={<Info></Info>} severity="error" sx={{ marginBottom: 4 }}>
                        {validation.Message}
                    </Alert>
                }
                {
                    validation.Code == ValidationCode.VALID &&
                    <Alert icon={<Info></Info>} severity="success" sx={{ marginBottom: 4 }}>
                        {validation.Message}
                    </Alert>
                }
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Link href="/sign-in" variant="body2" color="error" sx={{ textDecoration: "none" }}>Go back to login</Link>
                    <Button variant="contained" color="error" onClick={onSendTemporaryPassword}>
                        Send Password
                    </Button>
                </Box>
            </Card>
        </Container>
    )
}